<template>
  <div class="sidebar__account-navigation mb-6">
    <h3 class="text-sm mb-2">{{ $t("dashboard.sidebar_account_header") }}</h3>
    <ul>
      <li v-if="!isOfficeLogin && isParentProfile && !isDemoAccess">
        <a :href="student?.paymentUrl" target="_blank" :class="{ inactive: !student?.paymentUrl }">
          <img src="@/assets/images/icons/payments.svg" />
          {{ $t("dashboard.sidebar_account_payments") }}
        </a>
      </li>
      <li v-tooltip="!student?.currentParentSignedAgreement ? {
        theme: 'es',
        content: 'Tylko osoba, która podpisała umowę, może<br/>zmieniać dane do zwrotów',
        html: true
      } : null" v-if="!isOfficeLogin &&
    isParentProfile && !isDemoAccess">
        <router-link :to="{ name: 'Main.PaymentReturn' }"
          :class="{ inactive: isOfficeLogin || !student?.currentParentSignedAgreement, 'active-payments-return': highlightPaymentsReturn() }">
          <img :src="highlightPaymentsReturn()
            ? require('@/assets/images/icons/quill_filled.svg')
            : require('@/assets/images/icons/quill.svg')
            " />
          {{ $t("dashboard.sidebar_account_payments_returns") }}
        </router-link>
      </li>
      <li v-if="!isOfficeLogin && isParentProfile && !isDemoAccess && student?.wasSentStudentDeclaration">
        <router-link :to="{ name: 'Main.Declarations' }"
          :class="{ inactive: isOfficeLogin, 'active-declarations': highlightDeclarationsReturn() }">
          <img :src="highlightDeclarationsReturn()
            ? require('@/assets/images/icons/declarations_filled.svg')
            : require('@/assets/images/icons/declarations.svg')
            " />
          {{ student?.declarationHasAdvance ? $t("dashboard.sidebar_declarations_advance") :
            $t("dashboard.sidebar_declarations") }}
        </router-link>
      </li>
      <li v-tooltip="!student?.currentParentSignedAgreement && !student?.downloadAgreementUrl ? {
        theme: 'es',
        content: 'Tylko osoba, która podpisała umowę, może<br/>pobrać umowę',
        html: true
      } : null" v-if="!isOfficeLogin && isParentProfile && !isDemoAccess">
        <a :href="student?.downloadAgreementUrl" target="_blank" :class="{ inactive: !student?.downloadAgreementUrl }">
          <img src="@/assets/images/icons/download-document.svg" />
          {{ $t("dashboard.sidebar_account_agreement") }}
        </a>
      </li>
      <li>
        <router-link :to="{ name: 'Main.ChangePassword' }"
          :class="{ inactive: isOfficeLogin, 'active-change-password': highlightPasswordChange() }">
          <img :src="highlightPasswordChange()
            ? require('@/assets/images/icons/password_change_filled.svg')
            : require('@/assets/images/icons/password_change.svg')
            " />
          {{ $t("dashboard.sidebar_account_change_password") }}
        </router-link>
      </li>
      <li>
        <button class="sidebar__logout-button" :class="[
          (isOfficeLogin || logoutInProgress || getIsLogoutBlocked) && 'inactive',
          logoutHighlighted && 'sidebar__logout-button--highlight',
        ]" @click="logoutUser">
          <img src="@/assets/images/icons/logout_2.svg" />
          {{ $t("auth.logout") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'AccountNavigation',
  data() {
    return {
      logoutInProgress: false,
      logoutHighlighted: false,
    };
  },
  props: {
    routeName: String,
  },
  methods: {
    ...mapActions('students', ['getStudentAgreementFile']),
    async logoutUser() {
      this.logoutInProgress = true;
      try {
        await this.$store.dispatch('auth/logout');
      } catch (e) {
        console.error(e);
      } finally {
        this.logoutInProgress = false;
      }
    },

    highlightLogout(value) {
      this.logoutHighlighted = value;
    },

    highlightPasswordChange() {
      return this.routeName === 'Main.ChangePassword';
    },

    highlightPaymentsReturn() {
      return this.routeName === 'Main.PaymentReturn';
    },

    highlightDeclarationsReturn() {
      return this.routeName === 'Main.Declarations';
    },

    async handleDownloadUserAgreement() {
      const agreementFile = await this.getStudentAgreementFile(this.student?.code);
      const url = window.URL.createObjectURL(new Blob([agreementFile]));
      const link = document.createElement('a');

      const fileName = `${Math.floor(1000 + Math.random() * 9000)}${this.student?.code}.zip`;
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
  },

  computed: {
    ...mapState('students', ['student']),
    ...mapGetters('auth', [
      'isOfficeLogin',
      'isAgentProfile',
      'isParentProfile',
      'isDemoAccess',
      'getIsLogoutBlocked',
    ]),
  },
  mounted() {
    this.$root.$on('handle-logout-highlight', this.highlightLogout);
  },
  beforeDestroy() {
    this.$root.$off('handle-logout-highlight', this.highlightLogout);
  },
};
</script>

<style lang="scss" scoped>
.inactive {
  @apply opacity-25 pointer-events-none;
}

.active-change-password,
.active-payments-return,
.active-declarations {
  background-color: #fce3f0;
  color: #c60d65;
  border-radius: 4px;
  transition: 0.3s;

  &:hover {
    color: #c60d65 !important;
  }
}

.sidebar {
  &__account-navigation {
    @apply flex flex-col;

    li>* {
      @apply flex items-center w-full no-underline p-1;
      grid-gap: 8px;
      transition: color 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

      &:hover {
        @apply text-grey-dark;
      }
    }
  }

  &__logout-button {
    &--highlight {
      padding: 10px 20px;
      background-color: #ec268f;
      color: #fff !important;
      text-align: center;
      border-radius: 20px;
      width: min-content !important;
      white-space: nowrap;
      align-self: flex-start;
      text-decoration: none;
    }
  }
}
</style>
